import React, { useState } from "react";

import PostsGrid from '../../components/PostsGrid/PostsGrid.jsx';
import Button from '../../components/Button/Button.jsx';

import './RelatedPosts.scss';

const DEFAULT_NUMBER_OF_POSTS = 3;

export default function RelatedPosts({ related }) {
  const [visiblePosts, setVisiblePosts] = useState(DEFAULT_NUMBER_OF_POSTS);

  const canLoadMorePosts = visiblePosts < Object.keys(related).length;

  return (
    <div className="related-blogs-section">
      <div className="related-blogs-section-wrapper">
        <div className="related-heading">
          <h3>Related Posts</h3>
        </div>
        <PostsGrid posts={related.slice(0, visiblePosts)} />
        {canLoadMorePosts && (
          <div className="related-load-more">
            <Button
              title="Load more posts"
              onClick={() => setVisiblePosts(visiblePosts + DEFAULT_NUMBER_OF_POSTS)}
            />
          </div>

        )}
      </div>
    </div>
  );
};
